import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { useState, useEffect } from "react";
import { ContactInfo } from "../types/contactInfo";
import dbJson from "../data/db.json";
import { MapBlock } from "./shared/MapBlock";
import { ScrollToTopButton } from "./ui/scrollToTopButton";

export const ContactsPage = () => {
  const [contactInfo, setContactInfo] = useState<ContactInfo[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const data = dbJson.contacntInfo.map((item) => ({
      ...item,
      coords: item.coords as [number, number],
    }));

    setContactInfo(data);
    setLoading(false);
  }, []);

  return (
    <div className="pt-16 md:pt-20 min-h-screen bg-slate-50" data-testid="contacts-page">
      {/* Header */}
      <div className="bg-white border-b border-slate-200 py-12">
        <div className="container-custom">
          <h1 className="text-3xl md:text-4xl font-bold text-slate-900 uppercase tracking-tight mb-4">
            Контакты
          </h1>
          <p className="text-slate-600 max-w-2xl">
            Свяжитесь с нами для приобретения продукции, консультации или обсуждения сотрудничества
          </p>
        </div>
      </div>

      <div className="container-custom py-16">
        <div>
          {loading ? (
            <div className="space-y-6">
              {[...Array(4)].map((_, i) => (
                <div key={i} className="h-24 bg-slate-200 animate-pulse rounded-sm" />
              ))}
            </div>
          ) : contactInfo ? (
            <div>{
              contactInfo.map(
                contact => (
                  <div
                    key={contact.address}
                    className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-stretch pb-8"
                  >
                    {/* Левая колонка */}
                    <div className="space-y-6">
                      <div className="bg-white p-6 border border-slate-200 rounded-sm">
                        <div className="flex items-start gap-4">
                          <div className="w-12 h-12 bg-slate-100 rounded-sm flex items-center justify-center flex-shrink-0">
                            <MapPin size={24} className="text-[#0056D2]" />
                          </div>
                          <div>
                            <h3 className="font-semibold text-slate-900 mb-1">Адрес</h3>
                            <p className="text-slate-600">{contact.address}</p>
                          </div>
                        </div>
                      </div>

                      <div className="bg-white p-6 border border-slate-200 rounded-sm">
                        <div className="flex items-start gap-4">
                          <div className="w-12 h-12 bg-slate-100 rounded-sm flex items-center justify-center flex-shrink-0">
                            <Phone size={24} className="text-[#0056D2]" />
                          </div>
                          <div>
                            <h3 className="font-semibold text-slate-900 mb-1">Телефон</h3>
                            <a href={`tel:${contact.phone}`} className="text-[#0056D2] hover:underline text-lg font-medium">
                              {contact.phone}
                            </a>
                          </div>
                        </div>
                      </div>

                      <div className="bg-white p-6 border border-slate-200 rounded-sm" data-testid="contact-email">
                        <div className="flex items-start gap-4">
                          <div className="w-12 h-12 bg-slate-100 rounded-sm flex items-center justify-center flex-shrink-0">
                            <Mail size={24} className="text-[#0056D2]" />
                          </div>
                          <div>
                            <h3 className="font-semibold text-slate-900 mb-1">Email</h3>
                            <a href={`mailto:${contact.email}`} className="text-[#0056D2] hover:underline">
                              {contact.email}
                            </a>
                          </div>
                        </div>
                      </div>

                      <div className="bg-white p-6 border border-slate-200 rounded-sm" data-testid="contact-hours">
                        <div className="flex items-start gap-4">
                          <div className="w-12 h-12 bg-slate-100 rounded-sm flex items-center justify-center flex-shrink-0">
                            <Clock size={24} className="text-[#0056D2]" />
                          </div>
                          <div>
                            <h3 className="font-semibold text-slate-900 mb-1">Режим работы</h3>
                            <p className="text-slate-600">{contact.workHours}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Правая колонка */}
                    <div className="bg-white border border-slate-200 rounded-sm overflow-hidden min-h-[400px]">
                      <MapBlock
                        apiKey="KEY"
                        center={contact.coords}
                        balloonContent={contact.address}
                      />
                    </div>

                  </div>
                ))}
            </div>
          ) : (
            <p className="text-slate-500">Не удалось загрузить контактную информацию</p>
          )}
        </div>
        <ScrollToTopButton />
      </div >
    </div >
  );
};